<script>
    import config from './../config'
</script>

<footer class="footer">
    <div class="content has-text-centered">
        <p class="mb-5">
            <a
                href="{config.linkedinUrl}"
                class="social"
                rel="nofollow noopener"
                target="_blank"
            >
                <i class="fa-brands fa-linkedin fa-2xl fa-fw" />
            </a>
            <a
                href="{config.githubUrl}"
                class="social"
                rel="nofollow noopener"
                target="_blank"
            >
                <i class="fa-brands fa-github fa-2xl fa-fw" />
            </a>
            <a
                href="{config.stackoverflowUrl}"
                class="social"
                rel="nofollow noopener"
                target="_blank"
            >
                <i class="fa-brands fa-stack-overflow fa-2xl fa-fw" />
            </a>
        </p>
        <p style="font-weight: bold;">
            Damien ROCH - Senior Fullstack Web Developer
        </p>

        <p>
            Lovingly Made with <a
                href="https://bulma.io/"
                rel="nofollow noopener"
                target="_blank">Bulma</a
            >
            &
            <a
                href="https://svelte.dev/"
                rel="nofollow noopener"
                target="_blank">Svelte</a
            > from France
        </p>
    </div>
</footer>

<style>
    .footer {
        background-color: transparent;
        position: relative;
    }

    .footer p {
        background-color: transparent;
        font-size: 0.75rem;
        color: rgba(255,255,255,.4);
    }

    .footer a {
        color: rgba(255,255,255,.6);    
        font-weight: bold;
    }
    .footer a:hover{
        color: rgba(255,255,255,.9);         
    }
</style>
